module.exports = __webpack_public_path__ + "site_static/img/data-3.216975c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneimg/data-3.jpg
// module id = omtk
// module chunks = 0